var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "ghost" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Header")]),
      _c(
        "div",
        { staticClass: "d2-pt d2-pb" },
        [
          _c(
            "el-card",
            {
              staticClass: "d2-card",
              staticStyle: { width: "400px" },
              attrs: { shadow: "never" }
            },
            [_c("d2-demo-article")],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [_vm._v("Footer")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }